var pershpric = $("#persheetprice").val();
var sqftarea = $("#sqftarea").val();
var pershpric  = pershpric.substring(1);
var persqtftval = "$"+((pershpric / sqftarea).toFixed(2)) +" per sq. ft.";
if(sqftarea!=""){ $("#dynamicpersheet").html(persqtftval); }

$("#squares").on('change keyup', function () {
  	var sqftval = $(this).val();
    var sqftarea = $("#sqftarea").val();
  	var formula = (sqftval / sqftarea);
  	var totalsheets = Math.ceil(formula);
  	var pershpric = $("#persheetprice").val();
 	var pershpric  = pershpric.substring(1);
  	var grandtotal = (totalsheets*pershpric).toFixed(2);
    var persqtftval = "$"+((pershpric / sqftarea).toFixed(2)) +" per sq. ft.";
    $("#sheets").val(totalsheets); 
    $(".form-field--qty-select").addClass("hidden");  $(".form-field--qty-input").addClass("visible");
    $("#product-quantity-input").val(totalsheets);
    var res = "<p>Total Price</p><p class='tp'>$"+grandtotal+"</p>";
  	$(".totaltitleprice").html(res);
  	$("#dynamicpersheet").html(persqtftval);
});
/***** per sheet input ****/
$("#sheets").on('change keyup', function () {
  	var sheets = $(this).val();
    var sqftarea = $("#sqftarea").val();
  	var formula = (sheets * sqftarea).toFixed(2);
  	$("#squares").val(formula);
 	var pershpric = $("#persheetprice").val();
 	var pershpric  = pershpric.substring(1);
  	var grandtotal = (sheets*pershpric).toFixed(2);
    var persqtftval = "$"+((pershpric / sqftarea).toFixed(2)) +" per sq. ft.";
    $("#sheets").val(sheets); 
    $(".form-field--qty-select").addClass("hidden");  $(".form-field--qty-input").addClass("visible");
    $("#product-quantity-input").val(sheets);
    var res = "<p>Total Price</p><p class='tp'>$"+grandtotal+"</p>";
  	$(".totaltitleprice").html(res);
  	$("#dynamicpersheet").html(persqtftval);
  
});
/**** pop up calculate sqft****/
$("#poupsqft").on('click', function () {
  	var sqftval = $("#squarespopup").val();
    var sqftarea = $("#sqftarea").val();
  	var formula = (sqftval / sqftarea);
  	var totalsheets = Math.ceil(formula);
  	var pershpric = $("#persheetprice").val();
    var pershpric  = pershpric.substring(1);
  	var extrasheets =Math.ceil((sqftval*10/100)/sqftarea)+totalsheets;
  	$("#quantity").val(totalsheets);
    if(totalsheets==extrasheets){ var extrasheets = extrasheets+1; }
  	var html="You need "+totalsheets+" Sheets. We recommend that you order "+extrasheets+" Sheets (10% extra) to cover cuts and future repairs.";
  	$("#quantity").val(extrasheets);$("#resultdiv").html(html); $("#custom_addtocart").show();
});
/**** pop up calculate length width****/
$("#lenghtwidth").on('click', function () {
  if($("#lengthft").val()==""){ var lengthft =0;  }else{ var lengthft = ($("#lengthft").val())*12;}
  if($("#lengthin").val()==""){ var lengthin =0;  }else{ var lengthin = $("#lengthin").val();}
  if($("#widthft").val()==""){ var widthft =0;  }else{ var widthft = ($("#widthft").val())*12;}
  if($("#widthin").val()==""){ var widthin =0;  }else{ var widthin = $("#widthin").val();}
  
  var totallength = parseInt(lengthft) + parseInt(lengthin);	
     var totalwidth = parseInt(widthft)+parseInt(widthin);
    var totalvall = (totallength*totalwidth)/144;
  	var sqftarea = $("#sqftarea").val();
  	var totalsheets = Math.ceil(totalvall/sqftarea);
    var extrasheets =Math.ceil(((totalvall*10/100)+totalvall)/sqftarea);
  if(totalsheets==extrasheets){ var extrasheets = extrasheets+1; }
  	var html="You need "+totalsheets+" Sheets. We recommend that you order "+extrasheets+" Sheets (10% extra) to cover cuts and future repairs.";
  	$("#quantity").val(extrasheets);	
  $("#resultdiv").html(html); $("#custom_addtocart").show();
  	
});
/*** show pop up***/
$(".container-popup, #close").click(function(){
    $('.popup').hide(); $('.container-popup').hide();
     });
$("#showpopuptitles").click(function(){
    $('.popup').show(); $('.container-popup').show();
     });
